<template>
    <div>
        <NavBar></NavBar>
        <h3 class="my-3 mx-auto">Perfil estructural metálico en formato completo</h3>
        <p>En este apartado prodrá cotizar unicamente formatos completos de perfil estructural, sin incluir ningún
            tipo de servicio.</p>
        <CompSectionProfile @sendKiloPrice="getKiloPrice" @sendWeigthMeter="getWeigth" @sendLength="getDimensions">
        </CompSectionProfile>
        <PriceCompSection :getKiloPrice="kiloPrice" :getWeightMeter="weigth" :getLengthValue="length">
        </PriceCompSection>
    </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import CompSectionProfile from "@/components/CompleteSectionQuote/CompSectionProfileComponent.vue";
import PriceCompSection from "@/components/CompleteSectionQuote/CompSectionPricePerfTubComponent.vue";
export default {
    name: "CompleteSectionView",
    data() {
        return {
            kiloPrice: 0,
            weigth: 0,
            length: 0,
        };
    },
    methods: {
        getKiloPrice(data) {
            this.kiloPrice = data;
            // console.log("Desde el padre kiloPrice", this.kiloPrice);
        },
        getWeigth(data) {
            this.weigth = data;
            // console.log("Desde el padre weigth", this.weigth);
        },
        getDimensions(data) {
            this.length = data;
            // console.log("Desdde el padre length", this.length);
        }
    },
    components: {
        NavBar,
        CompSectionProfile,
        PriceCompSection,
    },
};
</script>